<div class="item_card_wrap">
    <div class="card_con">
        <img src="assets/imgs/bicycle_icon.png" alt="자전거 아이콘">
        <div class="text_box">
            <span>스마트 자전거</span>
        </div>
    </div>
</div>